import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Container, Spinner, Alert } from "reactstrap";
import { useAuth } from "../components/AuthProvider";
import { activatePartyPass } from "../service/auth";
import logo from "../assets/new-logo.png";

function PartyPassSuccess() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { updateZebraId } = useAuth();
  const [status, setStatus] = useState("loading"); // loading, success, error
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    const sessionId = searchParams.get("session_id");
    const authToken = localStorage.getItem("authToken");

    // Debug logging
    console.log("🎫 Party Pass Success - Session ID:", sessionId);
    console.log("🔑 Party Pass Success - Auth Token exists:", !!authToken);

    if (!sessionId) {
      setStatus("error");
      setErrorMessage("Invalid checkout session");
      return;
    }

    // Ensure user is authenticated before activating
    if (!authToken) {
      console.error("❌ No auth token found - user not authenticated");
      setStatus("error");
      setErrorMessage("Session expired. Please try signing up again.");
      return;
    }

    // Activate Party Pass by calling backend API
    const activatePass = async () => {
      try {
        // Call backend to activate Party Pass
        // Backend will set zebra_id (cron job validates with Stripe)
        const response = await activatePartyPass(sessionId);

        console.log("✅ Party Pass API Response:", response);
        console.log("📦 Response Data:", response.data);

        const zebra_id = response.data?.zebra_id || sessionId;

        console.log("🦓 Extracted Zebra ID:", zebra_id);

        if (zebra_id) {
          // Update the zebra_id in auth context and localStorage
          updateZebraId(zebra_id);

          // Clear purchase intent
          localStorage.removeItem("partyPassPurchaseIntent");

          setStatus("success");

          // Redirect to home after 3 seconds
          setTimeout(() => {
            navigate("/");
          }, 3000);
        } else {
          setStatus("error");
          setErrorMessage("Failed to activate Party Pass. Please contact support.");
        }
      } catch (error) {
        console.error("❌ Error activating Party Pass:", error);
        console.error("❌ Error Response:", error.response);
        console.error("❌ Error Data:", error.response?.data);
        setStatus("error");
        setErrorMessage(
          error.response?.data?.message ||
          error.message ||
          "Failed to activate Party Pass. Please contact support."
        );
      }
    };

    activatePass().catch((error) => {
      // Extra safety net to catch any unhandled rejections
      console.error("Unhandled error in activatePass:", error);
      setStatus("error");
      setErrorMessage("An unexpected error occurred. Please contact support.");
    });
  }, [searchParams, updateZebraId, navigate]);

  return (
    <Container className="text-center" style={{ marginTop: "100px" }}>
      <img src={logo} alt="Vibe Stream" style={{ width: "200px", marginBottom: "30px" }} />

      {status === "loading" && (
        <div>
          <Spinner color="primary" style={{ width: "3rem", height: "3rem" }} />
          <h3 className="mt-4">Activating your Party Pass...</h3>
          <p className="text-muted">Please wait while we confirm your payment</p>
        </div>
      )}

      {status === "success" && (
        <div>
          <Alert color="success">
            <h2>🎉 Party Pass Activated!</h2>
            <p className="mb-0">You now have unlimited skips. Enjoy!</p>
          </Alert>
          <p className="text-muted mt-3">Redirecting you to the homepage...</p>
        </div>
      )}

      {status === "error" && (
        <div>
          <Alert color="danger">
            <h4>Oops!</h4>
            <p className="mb-0">{errorMessage}</p>
          </Alert>
          <button
            className="btn btn-primary mt-3"
            onClick={() => navigate("/")}
          >
            Return to Home
          </button>
        </div>
      )}
    </Container>
  );
}

export default PartyPassSuccess;
